import { applyMiddleware, compose, createStore } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import * as History from 'history';
import rootReducer from './redux';

export const history = History.createBrowserHistory();
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'], // only navigation will be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

if (window.__RUNTIME_CONFIG__.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

export const Store = createStore(
  connectRouter(history)(persistedReducer),
  composedEnhancers,
);
export const StoreInstance = Store;

export default () => {
  const persistor = persistStore(Store);
  return { persistor, store: Store };
};
